<template>
  <el-dialog
    title="反馈内容"
    :visible.sync="visible"
    class="width984"
    :append-to-body="true"
    @close="close"
  >
    <el-form ref="form" :model="model" label-position="top">
      <el-form-item label="类型：" prop="TypeID">
        <el-select v-model="model.TypeID" placeholder="请选择" class="width100">
          <el-option label="投诉" :value="1" />
          <el-option label="建议" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item label="内容：" prop="Body">
        <el-input
          v-model="model.Body"
          placeholder="反馈内容"
          maxlength="200"
          type="textarea"
          :rows="6"
          class="width100"
        />
      </el-form-item>
      <br />
      <el-form-item label="最多上传5张" prop="dealImgFileList">
        <el-upload
          :class="{ disUploadSty: noneBtnImg }"
          :headers="upload.headers"
          :action="upload.url"
          list-type="picture-card"
          :limit="number"
          :on-change="dealImgChange"
          :on-remove="handleDealImgRemove"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
          :file-list="model.dealImgFileList"
          accept=".jpeg,.jpg,.gif,.png"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button class="submit-btn" @click="submit()">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getToken, setToken, removeToken } from "@/util/auth";
import { FeedBack } from "@/api/member";
export default {
  props: {
    id: [String, Number],
  },
  data() {
    return {
      visible: false,
      noneBtnImg: false,
      number: 5,
      uploadList: [],
      fileType: ["jpg", "jpeg", "png", "gif"],
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: "",
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: { Token: getToken() },
        // 上传的地址
        url: this.baseUrl + "/pc/Common/UploadImage?modName=feedback",
      },
      model: { TypeID: "", Body: "", dealImgFileList: [] },
    };
  },

  methods: {
    submit() {
      const data = {
        TypeID: this.model.TypeID,
        Body: this.model.Body,
        ImgPaths: this.uploadList.map((it) => it.url).join(","),
      };
      FeedBack(data).then((res) => {
        if (res.code == 0) {
          this.$message.success("提交成功");
          this.close(true);
        } else {
        }
      });
    },
    open() {
      this.visible = true;
    },
    close(flag) {
      this.visible = false;
      this.model = {
        Body: "",
        TypeID: "",
        dealImgFileList: [],
      };
      if (flag) {
        this.$emit("closePop");
      }
    },
    dealImgChange(file, fileList) {
      this.noneBtnImg = fileList.length >= this.number;
    },
    handleDealImgRemove(file, fileList) {
      this.noneBtnImg = fileList.length >= this.number;
      const list = this.uploadList.filter((item) => item.name != file.name);
      this.uploadList = list;
    },
    handleAvatarSuccess(res, file) {
      if (res.code === 0) {
        this.uploadList.push({
          name: res.data.FileName,
          url: res.data.FilePath,
        });
      } else {
      }
    },

    beforeAvatarUpload(file) {
      // 校检文件类型
      if (this.fileType) {
        let fileExtension = "";
        if (file.name.lastIndexOf(".") > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
        }
        const isTypeOk = this.fileType.some((type) => {
          if (file.type.indexOf(type) > -1) return true;
          if (fileExtension && fileExtension.indexOf(type) > -1) return true;
          return false;
        });
        if (!isTypeOk) {
          this.$message.error(
            `文件格式不正确, 请上传${this.fileType.join("/")}格式文件!`
          );
          return false;
        }
      }
      // 校检文件大小
      // if (this.fileSize) {
      //   const isLt = file.size / 1024 / 1024 < this.fileSize;
      //   if (!isLt) {
      //     this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`);
      //     return false;
      //   }
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .disUploadSty .el-upload--picture-card {
  display: none; /* 上传按钮隐藏 */
}
.width984 {
  ::v-deep .el-dialog {
    width: 984px;
  }
  .width100 {
    ::v-deep .el-textarea__inner {
      font-size: 16px;
      width: 100%;
    }
    ::v-deep .el-input__inner {
      font-size: 16px;
      width: 100%;
    }
  }
  ::v-deep .el-upload--picture-card {
    width: 300px;
    height: 225px;
  }
  ::v-deep .el-upload-list__item {
    width: 300px;
    height: 225px;
  }

  .el-icon-plus {
    margin-top: 90px;
  }
}
.submit-btn {
  width: 144px;
  height: 52px;
  background: #1d79ff;
  border-radius: 6px;
  font-size: 18px;
  color: #ffffff;
}
</style>
